import { Text } from "@imminently/react/ui/core/text";
import { Box } from "@mui/material";

import { RISK_COLOURS } from "@/resources/constants";
import { NEWS2Score } from "@/resources/types";

const styles = {
  riskScore: {
    display: "flex",
    justifyContent: "center",
    py: 0.5,
    borderRadius: 1,
    width: 70,
  },
};

const RiskScore = ({ riskScore }: { riskScore: NEWS2Score }) => {
  const bgcolor = RISK_COLOURS[riskScore.risk].main;

  return (
    <Box sx={{ ...styles.riskScore, bgcolor }}>
      <Text bold variant="caption">
        {riskScore.score}
      </Text>
    </Box>
  );
};

export default RiskScore;
